import React, { Component } from 'react';
import Breadcrumb from 'react-bootstrap/lib/Breadcrumb';
import { LinkContainer } from 'react-router-bootstrap';
import ErrorBoundary from '../../utils/error-boundary';
import { withTranslation } from 'react-i18next';

class PageWrap extends Component {
  render() {
    const { children, page, t } = this.props;
    return (
      <ErrorBoundary>
        <div className="page-container-bg-solid">
          <div className="page-content">
            <div className="page-bar page-bar-margin-20">
              <Breadcrumb className="page-breadcrumb">
                <LinkContainer to="/">
                  <Breadcrumb.Item>{t('Home')}</Breadcrumb.Item>
                </LinkContainer>
                <Breadcrumb.Item active>{page}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <div>
              {children}
            </div>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

export default withTranslation()(PageWrap);
